import * as React from 'react';
import { observer } from 'mobx-react';
import './imageUploadPane.module.scss';
import { observable, makeObservable } from 'mobx';
import { Plus } from './images/Plus';
import classNames from 'classnames';
import { OverlayContent } from '../../../../commonv3/components/molecules/layout/OverlayPage';
import { ImageUploadPaneState } from './states/ImageUploadPaneState';

type InnerProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectFiles?: (files: any) => void;
  url?: string;
};

const DesktopImageUploadPane = observer(
  class DesktopImageUploadPane extends React.Component<InnerProps> {
    pageState = new ImageUploadPaneState();

    constructor(props: InnerProps) {
      super(props);

      makeObservable(this, {
        pageState: observable,
      });
    }

    render() {
      const { url, onSelectFiles } = this.props;
      const { showOverlayImage } = this.pageState;
      return (
        <div>
          <div>
            {url ? (
              <div>
                <div styleName="h3">
                  <div>ワークシートをアップロードしよう</div>
                  <div>
                    <label styleName="replace-button">
                      置き換える
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => onSelectFiles && onSelectFiles(e.target.files)}
                      />
                    </label>
                  </div>
                </div>
                <img src={url} styleName="image-area" onClick={() => this.pageState.openOverlayImage()} />
              </div>
            ) : (
              <div>
                <div styleName="h3">ワークシートをアップロードしよう</div>
                <label styleName="upload-area">
                  <div styleName="upload-area-content">
                    <div styleName="wrapper">
                      <div styleName="upload-icon">
                        <Plus color="white" />
                      </div>
                    </div>
                    <div styleName="wrapper">
                      <div styleName="upload-text">アップロードする</div>
                    </div>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => onSelectFiles && onSelectFiles(e.target.files)}
                  />
                </label>
              </div>
            )}
          </div>
          <OverlayContent
            open={showOverlayImage}
            onRequestClose={() => this.pageState.closeOverlayImage()}
            childElem={(st, setRef) => {
              return (
                <div styleName="modal">
                  <div styleName="button-wrapper">
                    <div styleName={classNames('close-button', st)} onClick={() => this.pageState.closeOverlayImage()}>
                      <div styleName={classNames('close-button-inner', st)}>
                        <div styleName="bar leftright" />
                        <div styleName="bar rightleft" />
                      </div>
                    </div>
                  </div>
                  <div styleName="modal-body" ref={setRef}>
                    <img src={url} styleName="overlay-image" />
                  </div>
                </div>
              );
            }}
          />
        </div>
      );
    }
  }
);

const SpImageUploadPane = observer(
  class SpImageUploadPane extends React.Component<InnerProps> {
    pageState = new ImageUploadPaneState();

    constructor(props: InnerProps) {
      super(props);

      makeObservable(this, {
        pageState: observable,
      });
    }

    render() {
      const { url, onSelectFiles } = this.props;
      const { showOverlayImage } = this.pageState;
      return (
        <div>
          <div>
            {url ? (
              <div>
                <div styleName="h3">ワークシートをアップロードしよう</div>
                <img src={url} styleName="image-area" onClick={() => this.pageState.openOverlayImage()} />
                <div>
                  <label styleName="replace-button">
                    置き換える
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => onSelectFiles && onSelectFiles(e.target.files)}
                    />
                  </label>
                </div>
              </div>
            ) : (
              <div>
                <div styleName="h3">ワークシートをアップロードしよう</div>
                <label styleName="upload-area">
                  <div styleName="upload-area-content">
                    <div styleName="wrapper">
                      <div styleName="upload-icon">
                        <Plus color="white" />
                      </div>
                    </div>
                    <div styleName="wrapper">
                      <div styleName="upload-text">アップロードする</div>
                    </div>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => onSelectFiles && onSelectFiles(e.target.files)}
                  />
                </label>
              </div>
            )}
          </div>
          <OverlayContent
            open={showOverlayImage}
            onRequestClose={() => this.pageState.closeOverlayImage()}
            childElem={(st, setRef) => {
              return (
                <div styleName="modal">
                  <div styleName="button-wrapper">
                    <div styleName={classNames('close-button', st)} onClick={() => this.pageState.closeOverlayImage()}>
                      <div styleName={classNames('close-button-inner', st)}>
                        <div styleName="bar leftright" />
                        <div styleName="bar rightleft" />
                      </div>
                    </div>
                  </div>
                  <div styleName="modal-body" ref={setRef}>
                    <img src={url} styleName="overlay-image" />
                  </div>
                </div>
              );
            }}
          />
        </div>
      );
    }
  }
);

type ImageUploadPaneType = 'desktop' | 'sp';

type Props = InnerProps & {
  type: ImageUploadPaneType;
};

export const ImageUploadPane = ({ type, onSelectFiles, url }: Props) => {
  if (type === 'sp') {
    return <SpImageUploadPane onSelectFiles={onSelectFiles} url={url} />;
  } else {
    return <DesktopImageUploadPane onSelectFiles={onSelectFiles} url={url} />;
  }
};
